/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';

/** Components */
import TrafficLightIndicator from './TrafficLightIndicator';

const StudentTotalAverageCell = ({
  displayTotal,
  classAverage,
  totalMarksAvailable,
  totalMarksObtained,
  className,
}) => {
  if (!displayTotal) {
    return <td className={cx('total-avg-cell', className)}>-</td>;
  }

  // Calculate the Student Average
  /* eslint-disable no-mixed-operators */
  const studentPercentResult = totalMarksAvailable
    ? Math.round10((totalMarksObtained / totalMarksAvailable) * 100, -1)
    : '-';

  return (
    <td className={cx('total-avg-cell', 'student-total-avg-cell', className)}>
      <TrafficLightIndicator a={studentPercentResult} b={classAverage}>
        {`${studentPercentResult}%`}
      </TrafficLightIndicator>
    </td>
  );
};

export default StudentTotalAverageCell;
